import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Divider from '@material-ui/core/Divider'
import copy from 'copy-to-clipboard'
import { addToast } from '../../utils/toast'
import { store } from '@redux/store'
import axios from 'axios'
import { getCodeMsg } from '../../utils/translation'
import { ACTION_TYPE as AUTH_ACTION_TYPE } from '@redux/reducers/auth'
import { ACTION_TYPE as DATA_SERVICE_ACTION_TYPE } from '@redux/reducers/data-service'

const initialState = {
    dialogOpen: false,
    pf_sub_pf_id: '',
    singleWalletUrl: 'https://',
    data: {},
    content: {
        session_id: '4 取得连线(Get Session)：',
        balance: '4-1 查询玩家馀额(Get Balance)：',
        transfer: '4-2 玩家转帐(Transfer)：',
        award: '3-4 活动派奖记录(Award)：',
    },
    page: 'setting',
    testUrl: '',
    testAccount: '',
    testResult: null,
}

class EditUserDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EditSingleWalletDialog')
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(pf_sub_pf_id, data) {
        if (Object.keys(data).length > 0) {
            this.setState({
                singleWalletUrl: data.session_id.replace('/rich88/session_id', ''),
                pf_sub_pf_id,
                data,
                dialogOpen: true,
            })
        } else {
            this.setState({
                pf_sub_pf_id,
                dialogOpen: true,
            })
        }
    }

    closeDialog() {
        this.setState({ ...initialState })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    getTestAction() {
        return this.state.page.replace('test-', '')
    }

    getResponseMessage(res) {
        const code = res.data.code === undefined ? '500' : res.data.code
        const msg = res.data.msg
        const errMsg = getCodeMsg(code)
        if (errMsg.toString() === code.toString() || (msg && getCodeMsg(code, { lng: 'en' }) !== msg)) {
            return msg
        }
        return errMsg
    }

    // 驗證 url call api 沒用 utils.apiReq 是因為這邊要直接將api 結果印在頁面上取資料的格式與共用函式不符合所以另寫
    validateUrl(method, apiUrl, params, successCallback, errorCallback) {
        if (!store.getState().auth) {
            addToast('Auth service not ready.', 'error')
            return
        }
        const server = process.env.REACT_APP_ENVIROMENT === 'local' ? '' : API.ZIO_CENTER_SERVER

        const config = {
            method: method,
            url: server + apiUrl,
            headers: {
                Authorization: store.getState().auth.token,
            },
        }

        config.data = params

        axios(config)
            .then((res) => {
                if (res.data.code === 0) {
                    if (successCallback instanceof Function) {
                        successCallback(res.data)
                    }
                } else {
                    addToast(this.getResponseMessage(res), 'error')

                    if (res.data.code === 16001 || res.data.code === 16002) {
                        // TODO: need group up the actions below
                        store.dispatch({ type: AUTH_ACTION_TYPE.LOGOUT })
                        store.dispatch({ type: DATA_SERVICE_ACTION_TYPE.CLEAR })
                        return
                    }

                    if (errorCallback instanceof Function) {
                        errorCallback(res.data)
                    }
                }
            })
            .catch((err) => {
                if (err.response) {
                    addToast(this.getResponseMessage(err.response), 'error')
                }
                if (errorCallback instanceof Function) {
                    errorCallback(err)
                }
            })
    }

    render() {
        return (
            <Dialog fullWidth={true} maxWidth={'md'} open={this.state.dialogOpen} onClose={() => this.setState({ ...initialState })}>
                <DialogTitle>{this.t('setSingleWalletUrl')}</DialogTitle>
                <DialogContent>
                    <div className={this.props.classes.formContainer}>
                        <div className={this.props.classes.formColContent}>
                            <div>PF_ID : </div>
                            <div>{this.state.pf_sub_pf_id}</div>
                        </div>
                        {this.state.page === 'setting' ? (
                            <div>
                                <div className={this.props.classes.formTitle}>
                                    <div>{this.t('setSingleWalletUrl')} : </div>
                                    <div>
                                        <input
                                            value={this.state.singleWalletUrl}
                                            onChange={(event) => {
                                                const value = event.target.value
                                                this.setState({
                                                    singleWalletUrl: value,
                                                })
                                            }}
                                            className={this.props.classes.setSingleWalletUrlInput}
                                        />
                                        <div className={this.props.classes.setSingleWalletUrlInput}>{`URL 格式：https://{业主URL}`}</div>
                                    </div>
                                </div>
                                {['session_id', 'balance', 'transfer', 'award'].map((item) => {
                                    return (
                                        <div key={item}>
                                            <div className={this.props.classes.colTitle}>{this.t(item)}</div>
                                            {this.state.data[item] && (
                                                <div className={this.props.classes.formColContent}>
                                                    <div>{this.state.data[item]}</div>
                                                    <div>
                                                        <span
                                                            onClick={() => {
                                                                copy(this.state.data[item], { debug: true })
                                                            }}
                                                            className={this.props.classes.testBtn}>
                                                            複製
                                                        </span>
                                                        <span
                                                            onClick={() => {
                                                                this.setState({
                                                                    page: `test-${item}`,
                                                                    testUrl: this.state.data[item],
                                                                })
                                                            }}
                                                            className={this.props.classes.testBtn}>
                                                            測試
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        ) : (
                            <div>
                                <div className={this.props.classes.formTitle}>
                                    <div>{this.t('callBackUrl')} : </div>
                                    <div>
                                        <input value={this.state.testUrl} disabled className={this.props.classes.setSingleWalletUrlInput} />
                                    </div>
                                </div>
                                {this.getTestAction() !== 'session_id' && (
                                    <div className={this.props.classes.formTitle}>
                                        <div>{this.t('testAccount')} : </div>
                                        <div>
                                            <input
                                                value={this.state.testAccount}
                                                onChange={(event) => {
                                                    const value = event.target.value
                                                    this.setState({
                                                        testAccount: value,
                                                    })
                                                }}
                                                className={this.props.classes.setSingleWalletUrlInput}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className={this.props.classes.colTitle}>{this.t('testResult')} :</div>
                                <div className={this.props.classes.testResult}>
                                    {this.state.testResult && <pre>{JSON.stringify(this.state.testResult, null, 2)}</pre>}
                                </div>
                            </div>
                        )}
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    {this.state.page !== 'setting' && (
                        <Button variant="contained" onClick={() => this.setState({ page: `setting` })} color="primary">
                            {this.t('back')}
                            {this.t('setting')}
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        onClick={() => {
                            if (this.state.page === 'setting') {
                                const isRegister = this.state.singleWalletUrl === initialState.singleWalletUrl
                                utils.apiRequest(
                                    isRegister ? 'post' : 'put',
                                    isRegister ? API.SINGLE_WALLET_REGISTER : API.SINGLE_WALLET,
                                    {
                                        pf_sub_pf_id: this.state.pf_sub_pf_id,
                                        url: this.state.singleWalletUrl,
                                    },
                                    (_data) => {
                                        this.closeDialog()
                                    },
                                    (_err) => {}
                                )
                            } else {
                                this.validateUrl(
                                    'post',
                                    API.SINGLE_WALLET_VALIDATE,
                                    {
                                        action: this.getTestAction(),
                                        pf_sub_pf_id: this.state.pf_sub_pf_id,
                                        pf_account: this.state.testAccount,
                                    },
                                    (data) => {
                                        this.setState({
                                            testResult: data,
                                        })
                                    },
                                    (err) => {
                                        this.setState({
                                            testResult: err,
                                        })
                                    }
                                )
                            }
                        }}
                        color="primary">
                        {this.t(this.state.page === 'setting' ? 'save' : 'testCallBackUrl')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        colTitle: {
            paddingTop: '20px',
        },
        editorEditor: {
            height: '300px',
            padding: '0 14px',
            border: 'solid 1px',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        formContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: 'auto',
        },
        formTitle: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '20px',
        },
        setSingleWalletUrlInput: {
            marginLeft: '40px',
            width: '650px',
        },
        formColContent: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        testBtn: {
            cursor: 'pointer',
            paddingLeft: '20px',
            color: '#69131C',
        },
        testResult: {
            marginTop: '10px',
            backgroundColor: '#F2F2F2',
            paddingTop: '15px',
            paddingBottom: '15px',
            minHeight: '100px',
            paddingLeft: '10px',
        },
    }
}

EditUserDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EditUserDialog)
